var offsetX = 0;
var offsetY = 0;
var width = 40;
var height = 20;
var rotate = 0;
var marginX = 2.0;
var marginY = 2.0;
var barCodeWidth = width - marginX * 2;
var barCodeHeight = height - marginY * 2;
var fontSize = 3.2;

//文本打印数据
export const barcodePrintData = {
  InitDrawingBoardParam: {
    width: 40,
    height: 30,
    rotate: 0,
    path: "ZT001.ttf",
    verticalShift: 0,
    HorizontalShift: 0,
  },

  elements: [
    {
      type: "text",
      json: {
        x: 2,
        y: 2,
        height: 4.3,
        width: 34,
        value: "数据线",
        codeType: 20,
        rotate: 0,
        fontSize: 2.6,
        textHeight: 3.2,
        textPosition: 0,
      },
    },
    {
      type: "barCode",
      json: {
        x: 2,
        y: 8,
        height: 15,
        width: 30,
        value: "00001",
        codeType: 20,
        rotate: 0,
        fontSize: 3.2,
        textHeight: 3.2,
        textPosition: 0,
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/utils/printData/Barcode.js